/**
 * Mesh booking widget — brand + problem → repair form or WhatsApp.
 * Progressive enhancement only; defaults work without JS.
 */
(function () {
  var root = document.querySelector("[data-mesh-booking]");
  if (!root) return;

  var brand = "";
  var problem = "";
  var formUrl = root.getAttribute("data-form-url") || "/pages/reparacion-moviles-formulario";
  var waBase = root.getAttribute("data-wa-url") || "";
  var useWa = root.getAttribute("data-use-wa") === "true";
  var cta = root.querySelector("[data-mesh-booking-cta]");

  function syncCta() {
    if (!cta) return;
    var msg =
      "Hola, quiero presupuesto" +
      (brand ? " para " + brand : "") +
      (problem ? " — " + problem : "") +
      ".";
    if (useWa && waBase) {
      cta.href = waBase + (waBase.indexOf("?") >= 0 ? "&" : "?") + "text=" + encodeURIComponent(msg);
    } else {
      var q = [];
      if (brand) q.push("marca=" + encodeURIComponent(brand));
      if (problem) q.push("problema=" + encodeURIComponent(problem));
      cta.href = formUrl + (q.length ? "?" + q.join("&") : "");
    }
  }

  root.querySelectorAll("[data-mesh-brand]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      brand = btn.getAttribute("data-mesh-brand") || btn.textContent.trim();
      root.querySelectorAll("[data-mesh-brand]").forEach(function (b) {
        b.setAttribute("aria-pressed", b === btn ? "true" : "false");
      });
      syncCta();
    });
  });

  root.querySelectorAll("[data-mesh-problem]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      problem = btn.getAttribute("data-mesh-problem") || btn.textContent.trim();
      root.querySelectorAll("[data-mesh-problem]").forEach(function (b) {
        b.setAttribute("aria-pressed", b === btn ? "true" : "false");
      });
      syncCta();
    });
  });

  syncCta();
})();
